import React, { useEffect, useRef } from 'react';
import { DotLottie } from '@lottiefiles/dotlottie-web';
// @ts-ignore
import wasmUrl from '@lottiefiles/dotlottie-web/dist/dotlottie-player.wasm?url';
import { resolveAssetUrl } from '@web-chat-core/ui-kit/helpers/electron';
import { LottieStage } from './view';

DotLottie.setWasmUrl(resolveAssetUrl(wasmUrl));

type WaitingApprovalLottieProps = {
    src: string;
    className?: string;
};

export const WaitingApprovalLottie = ({ src, className }: WaitingApprovalLottieProps) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const instanceRef = useRef<DotLottie | null>(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) return undefined;

        instanceRef.current?.destroy();
        instanceRef.current = null;

        const resolvedSrc = resolveAssetUrl(src);
        const instance = new DotLottie({
            canvas,
            src: resolvedSrc,
            autoplay: true,
            loop: true,
            layout: {
                fit: 'contain',
            },
            renderConfig: {
                devicePixelRatio: window.devicePixelRatio || 1,
            },
        });
        instanceRef.current = instance;

        return () => {
            instance.destroy();
            if (instanceRef.current === instance) {
                instanceRef.current = null;
            }
        };
    }, [src]);

    return <LottieStage ref={canvasRef} className={className} />;
};
